import { ROUNDTRIP } from 'sharedWebpack/IBE/lib/helpers/tripTypes';

const getTripDetails = (trips, airports, tripType) => {
  const [firstTrip] = trips;
  const lastTrip = trips[trips.length - 1];

  const originCode = firstTrip?.origin;
  const destinationCode = tripType === ROUNDTRIP ? firstTrip?.destination : lastTrip?.destination;

  const originInfo = airports[originCode] || {};
  const destinationInfo = airports[destinationCode] || {};

  return { firstTrip, lastTrip, originInfo, destinationInfo };
};

export default getTripDetails;
